/**
 *
 * Asynchronously loads the component for EventConfirmation
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const EventConfirmation = lazyLoad(
    () => import('./index'),
    module => module.default,
);
